import { render, staticRenderFns } from "./UserApprovalDlg.vue?vue&type=template&id=78c2f184&scoped=true&"
import script from "./UserApprovalDlg.vue?vue&type=script&lang=ts&"
export * from "./UserApprovalDlg.vue?vue&type=script&lang=ts&"
import style0 from "./UserApprovalDlg.vue?vue&type=style&index=0&id=78c2f184&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c2f184",
  null
  
)

export default component.exports